/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
import { FormikProps } from "formik";
import { individualRiderDetails } from "src/helpers/FormDetails/LoanDetails";
import { LoanDetails } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import AddMoreButton from "src/shared/AddMoreButton";
import Button from "@mui/material/Button";
import Resources from "src/config/Resources";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { useDispatch } from "react-redux";
import { setLoanDetails } from "src/redux/Actions/loanDetails";
import { useMutation } from "react-query";
import { deleteRiderDetails } from "src/services/Riders";
import store from "src/redux/store";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";
import CustomBackDrop from "src/shared/CustomBackDrop";
import { addOrdinalSuffix } from "src/helpers/FormDetails/ProposalDetails/resources";
import { useEffect, useState } from "react";
import { riderValidator } from "src/helpers/FormDetails/resources";
import RiderDetails from "./RiderDetails";

interface AddRidersProps {
  formik: FormikProps<LoanDetails>;
}

function AddRiders({ formik }: AddRidersProps) {
  const dispatch = useDispatch();
  const [ridersValidationErrorMessage, setRiderValidationErrorMessage] = useState<
    Record<string, any>
  >({ combined: "", riders: [] });
  const loanDetails = useAppSelector((state) => state.loanDetails);

  const { mutate: mutateRiderDelete, isLoading: isRiderDeleteLoading } = useMutation(
    deleteRiderDetails,
    {
      onSuccess: () => {
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            type: "success",
            duration: 4000,
            message: "Rider deleted successfully!"
          })
        );
      }
    }
  );

  const riders = formik.values.riderDetails;

  const handleAddingMoreRiderDetails = () => {
    const newRiders = [
      ...riders,
      individualRiderDetails({
        policyTermCode: formik?.values?.loan?.loanTermCode || "",
        premiumPaymentTermCode: formik?.values?.plan?.premiumPaymentTermCode || ""
      })
    ];
    formik.setFieldValue("riderDetails", newRiders);
    dispatch(setLoanDetails({ ...loanDetails, riderDetails: newRiders }));
  };

  const handleRemoveRiderFromState = (index: number) => {
    const newRiders = riders?.filter((_, i) => i !== index);
    formik.setFieldValue("riderDetails", newRiders);
    dispatch(setLoanDetails({ ...loanDetails, riderDetails: newRiders }));
  };

  const handleRemoveRider = (index: number) => {
    const riderId = formik?.values?.riderDetails?.[index]?.id;
    if (riderId) {
      mutateRiderDelete(riderId, {
        onSuccess: () => {
          handleRemoveRiderFromState(index);
        }
      });
    } else {
      handleRemoveRiderFromState(index);
    }
  };

  useEffect(() => {
    const validationMessage = riderValidator(formik?.values?.riderDetails);
    if (validationMessage?.combined) {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "warning",
          duration: 4000,
          message: validationMessage?.combined || ""
        })
      );
    }
    setRiderValidationErrorMessage(validationMessage);
  }, [
    formik?.values?.riderDetails,
    formik?.values?.loan?.loanTermCode,
    formik?.values?.loan?.loanAmount,
    formik?.values?.plan?.premiumPaymentTermCode
  ]);

  return (
    <div>
      <CustomBackDrop open={isRiderDeleteLoading} />
      <span className="font-montserrat text-black text-base font-bold mt-8 mb-3 flex flex-col space-y-1">
        Rider Details
        {!!ridersValidationErrorMessage?.combined && (
          <div className="text-hotShot text-xxs">
            <p>{ridersValidationErrorMessage?.combined}</p>
          </div>
        )}
      </span>
      {formik.values?.riderDetails?.map((_rider, index) => (
        <div key={index} className="mb-10">
          {/* Rider Heading */}
          <div className="flex justify-between items-start">
            <span className="font-montserrat text-black text-base font-bold mt-4 mb-6 flex flex-col space-y-1">
              {addOrdinalSuffix(index + 1)} Rider Detail
            </span>
            {index > 0 && (
              <Button
                variant="outlined"
                onClick={() => handleRemoveRider(index)}
                className="!text-black !uppercase h-10 !rounded-lg !border-2"
                classes={{ root: "!px-2 !min-w-0" }}
              >
                <img src={Resources.images.FormDetails.removeIcon} alt="remove" />
              </Button>
            )}
          </div>

          {/* Form Grid */}
          <RiderDetails formik={formik} riderIndex={index} />
        </div>
      ))}

      {/* Add More Button */}
      {formik?.values?.riderDetails?.length < 3 && (
        <div className="flex flex-col items-start space-y-6">
          <AddMoreButton label="Add More Rider" onClick={handleAddingMoreRiderDetails} />
        </div>
      )}
    </div>
  );
}

export default AddRiders;
